module.exports = __webpack_public_path__ + "img/chevron-right.ca9e6e1f.svg";